export enum InvitationRequestStatus {
  pending = 1,
  cancelled = 2,
  validated = 3,
  rejected = 4,
}

export interface InvitationRequestResponseDto {
  id: string;
  eventId: string;
  status: InvitationRequestStatus;
  createdOn: Date;
}
